import React, { useState, useEffect } from "react";
import NavBar from "./Components/NavBar";
import ItemEvento from "./Components/ItemEvento";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, useParams, Link } from "react-router-dom";
import { getDoc, setDoc, doc, query, where } from "firebase/firestore";
import ItemAsientosPaulet from "./Components/ItemAsientosPaulet";
import LlenarDatos from "./LlenarDatos";

import { db } from "./FirebaseConfig/firebase";
import { collection, getDocs } from "firebase/firestore";
import "./CSS/registrarParticipanteSalon.css";
import { addDoc } from "firebase/firestore";
import InfoEvento from "./Components/InfoEvento";
import Swal from "sweetalert2";
import ItemSalon from "./Components/ItemSalon";
import IncrementadorNum from "./Components/IncrementadorNum";
import { display } from "@mui/system";

const MySwal = withReactContent(Swal);

function RegistrarParticipanteSalon(props) {
  const { eliminarMesa, cip, nombreUsuario } = props;

  const [mesas, setMesas] = useState([]);

  const navigate = useNavigate();
  const { id } = useParams();
  const [estado, setEstado] = React.useState("");
  const [salon, setSalon] = React.useState("");
  const [nombre, setNombre] = React.useState("");
  const [fecha, setFecha] = React.useState("");
  const [hora, setHora] = React.useState("");

  const [maxAsientos, setMaxAsientos] = React.useState(
    localStorage.getItem("totalEntradas")
  );
  const [tipoEvento, setTipoEvento] = React.useState("");
  const [flagEntrada, setFlagEntrada] = React.useState(
    localStorage.getItem("flagEntradas")
  );

  //Variables para identificar si ya existe entradas reservadas para actualizarlas o recien va a reservar
  const [isNew, setIsNew] = React.useState(true);
  const [idUpdate, setIdUpdate] = React.useState();
  const [idDocReserva, setIdDocReserva] = React.useState();
  const [isPago, setIsPago] = React.useState(false);
  const [tickets, setTickets] = React.useState();
  const [costo, setCosto] = React.useState(0);

  const [descripcion, setDescripcion] = React.useState("");
  const [urlImagen, setUrlImage] = useState("");
  const [listaAsientos, setListaAsientos] = useState([]);
  const [listaRegistro, setListaRegistro] = useState([]);
  const [listaAsientosRegistrados, setListaAsientosRegistrados] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  const [listaAsientosExtras, setListaAsientosExtras] = React.useState(""); // lista de asientos que seran para pagar

  const [visMA, setvisMA] = React.useState(false); // Mostrar cuantos asientos son maximo
  const [visAC, setvisAC] = React.useState(false); // Mostrar asiento colegiado
  const [visAS, setvisAS] = React.useState(false); // Mostrar asiento en total

  const [derVisible, setDerVisible] = useState(false); // MOSTRAR Boton de continua
  const [tamanoForm, setTamanoForm] = React.useState(true); // Mostrar asiento en total
  const [cerrarVisible, setCerrarVisible] = React.useState(false); // Mostrar asiento en total
  const [showMore, setShowMore] = useState(false);
  const [asientosTemporal, setAsientosTemporal] = useState([]);

  //TIPOS DE COMIDA
  const [pollo, setPollo] = React.useState(0);
  const [chancho, setChancho] = React.useState(0);
  const [vegetariano, setVegetariano] = React.useState(0);
  const [totalComidas, setTotalComidas] = React.useState(0);
  const [blockComidas, setBlockComidas] = React.useState(false);
  const [seleccionComida, setSeleccionComida] = React.useState(true);

  //ver o mostrar "ver mas"
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  const getMesas = async () => {
    const cuponesList = collection(db, `EVENTOS/${id}/DistribucionSalon`);
    const data = await getDocs(cuponesList);
    const mesasObtenidas = data.docs.map((doc) => ({ ...doc.data() }));
    setMesas(mesasObtenidas);
  };

  //Funcion para mostrar detalles del evento
  const getEventoById = async (id) => {
    const evento = await getDoc(doc(db, "EVENTOS", id));
    if (evento) {
      setNombre(evento.data().nombre);
      setDescripcion(evento.data().descripcion);
      setUrlImage(evento.data().urlImagen);
      setEstado(evento.data().estado);
      setSalon(evento.data().salon);
      setFecha(evento.data().fecha);
	  setHora(evento.data().fecha.split(" ")[1]);

      //setMaxAsientos(evento.data().maxAsientos);

      setTipoEvento(evento.data().tipoEvento);
      localStorage.setItem("tipoEventoSalon", evento.data().tipoEvento);
    } else {
      console.log("no existe");
    }
    setDatosCargados(true);
  };

  //Funcion para llenar asientos reservados
  const buscarAsientosReservados = async () => {
    const cuponesList = collection(db, `EVENTOS/${id}/AsientosRegistrados`);
    const data = await getDocs(cuponesList);
    const tickets = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    setListaRegistro(tickets);
  };

  const btnContinuar = () => {
    setCerrarVisible(!cerrarVisible);

    if (tipoEvento != "Pago (sin comida)") {
      if (totalComidas != listaAsientos.length) {
        MySwal.fire(
          "",
          "Seleccione todos los tipos de comida por favor",
          "warning"
        );
      } else {
        if (listaAsientos.length > 0) {
          setSeleccionComida(!seleccionComida);
          setDerVisible(!derVisible);
          setTamanoForm(!tamanoForm);
        }
      }
    } else {
      if (localStorage.getItem("nombreLocal") != "CIP") {
        if (listaAsientos.length != maxAsientos) {
          MySwal.fire("", "Seleccione todos los asientos por favor", "warning");
        } else {
          if (listaAsientos.length > 0) {
            setSeleccionComida(!seleccionComida);
            setDerVisible(!derVisible);
            setTamanoForm(!tamanoForm);
          }
        }
      } else {
        if (listaAsientos.length > 0) {
          setSeleccionComida(!seleccionComida);
          setDerVisible(!derVisible);
          setTamanoForm(!tamanoForm);
        }
      }
    }
  };
  //Funcion para marcar asientos reservados
  const marcarAsientosReservados = async () => {
    const q = query(
      collection(
        db,
        `USUARIOS/${localStorage.getItem("idDocumento")}/AsientosRegistrados`
      ),
      where("idEvento", "==", id)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      setListaAsientos(doc.data().asientos.split(","));
      setIdDocReserva(doc.data().idEntrada);
      setIdUpdate(doc.id);
      setVegetariano(doc.data().vegetariano);
      setChancho(doc.data().chancho);
      setPollo(doc.data().pollo);
      setAsientosTemporal(doc.data().asientos.split(","));
      console.log(localStorage.getItem("flagEntradas"));
      if (localStorage.getItem("flagEntradas") == "true") {
        setMaxAsientos(
          parseInt(doc.data().asientos.split(",").length) +
            parseInt(maxAsientos)
        );
        console.log("dasdasdas");
      } else {
        console.log("dasdasdas");
        setMaxAsientos(maxAsientos);
      }
    });
  };

  function groupTablesSeats(listadeasientos) {
    const mesas = {};
    listadeasientos
      .split(",")
      .sort()
      .forEach((asiento) => {
        const numeroMesa = asiento.slice(0, -1);
        const letraAsiento = asiento.slice(-1);

        if (!mesas[numeroMesa]) {
          mesas[numeroMesa] = [];
        }

        mesas[numeroMesa].push(letraAsiento);
      });
    let resultado = "";
    Object.entries(mesas).map(
      ([numeroMesa, letraAsiento]) =>
        (resultado =
          resultado +
          `Mesa ${numeroMesa} ` +
          `(${letraAsiento.sort().join(",")}` +
          ") \n")
    );

    if (resultado && listaAsientos.length > 0) {
      const final = resultado.toString();

      return (
        <pre style={{ fontFamily: "sans-serif" }}>
          {showMore ? final : final.slice(0, 50)}
          {final.length > 50 ? (
            <button onClick={toggleShowMore} className="text-button">
              {showMore ? "Ver menos" : "Ver más ... "}
            </button>
          ) : null}
        </pre>
      );
    }
  }
  //Funcion para marcar asientos reservados
  const marcarAsientos = () => {
    const ticketsCollectionRef = db.collection(
      `EVENTOS/${id}/AsientosRegistrados`
    );
    ticketsCollectionRef.get().then((snapshot) => {
      const ticketsList = [];
      snapshot.forEach((doc) => {
        const ticket = { id: doc.id, ...doc.data() };
        ticketsList.push(ticket);
      });
      setTickets(ticketsList);
      console.log(ticketsList);
    });
  };
  //cerrar eventos
  const cerrar = () => {
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      navigate("../panelUser/eventos");
    } else {
      if (localStorage.getItem("nombreLocal") == "CIP") {
        navigate("../panelCDA/eventos");
      } else navigate("../panelAdmin/eventos");
    }
  };

  useEffect(() => {
    getEventoById(id);
    if (fecha == "") {
      getEventoById(id);
    }
    //console.log(id);
  }, [fecha]);

  useEffect(() => {
    getMesas();
    buscarAsientosReservados();
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      setDerVisible(false);
      marcarAsientosReservados();
    }
    if (localStorage.getItem("nombreLocal") == "CIP") {
      setDerVisible(false);
      marcarAsientosReservados();
    }
  }, []);
  useEffect(() => {
    var listilla = [];

    listaRegistro.map(({ asientos }) => {
      //console.log("asientos " + asientos + " lista asientos " + listaAsientos);
      //console.log(asientos==listaAsientos);

      if (localStorage.getItem("nombreLocal") == "CIP") {
        if (asientos != listaAsientos) {
          const answer_array = asientos.split(",");
          listilla = listilla.concat(answer_array);
          setListaAsientosRegistrados(listilla);
        } else {
          setIsNew(false);
        }
      } else {
        if (asientos == listaAsientos) {
          setIsNew(false);
        }
        const answer_array = asientos.split(",");
        listilla = listilla.concat(answer_array);
        setListaAsientosRegistrados(listilla);
      }
      //Codigo para modificar asientos que ya estan registrados
      /**/
      /*
      if (asientos == listaAsientos) {
        setIsNew(false);
      }
      const answer_array = asientos.split(",");
      listilla = listilla.concat(answer_array);
*/
      //console.log(listilla);
    });
  }, [listaRegistro]);

  useEffect(() => {
    Swal.fire({
      title: "Instrucciones",
      html: "1. Seleccione primero la mesa <br> 2. Seleccione los asientos que quiere reservar <br> 3. Click en el boton continuar  <br> 4.Verificar datos y click en el boton Reservar",
      icon: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Continuar",
    }).then((result) => {});

    if (localStorage.getItem("idLocal") == "") {
      const idLocal = localStorage.getItem("idLocal");
      //console.log("NO ES USER");
      navigate("../login");
    } else {
      setNombre(localStorage.getItem("nombreLocal"));
    }
    console.log("NO ES USER " + localStorage.getItem("flagEntradas", true));
  }, []);

  useEffect(() => {
    if (localStorage.getItem("nombreLocal") == "CIP") {
      setMaxAsientos("10000");
    }
    //
  }, [maxAsientos]);

  useEffect(() => {
    if (tipoEvento == "Colegiatura") {
      setvisAC(true);
    } else {
      setvisMA(true);
    }
  }, [tipoEvento]);

  useEffect(() => {
    if (localStorage.getItem("apellidoLocal") != "CDA") {
      setIsPago(true);
      //setCosto(listaAsientos.length * 80);
    }

    if (listaAsientos.length > 0) {
      setBlockComidas(false);
      setvisAS(true);
    }
  }, [listaAsientos]);
  //COMIDAS
  useEffect(() => {
    if (pollo + chancho + vegetariano <= listaAsientos.length) {
      setTotalComidas(pollo + chancho + vegetariano);
    } else {
      setBlockComidas(true);
    }
  }, [pollo, chancho, vegetariano]);

  useEffect(() => {
    console.log("CLICK EN LA MESA" + totalComidas + " " + listaAsientos.length);

    if (totalComidas >= listaAsientos.length) {
      setBlockComidas(true);
    } else {
      setBlockComidas(false);
    }
  }, [totalComidas]);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="eventos">
      <NavBar
        titulo="Reservar Participantes | Salón de eventos"
        imagen="cerrar"
        logoTitulo="eventos"
        cerrar={cerrar}
        cerrarVisible={cerrarVisible}
      ></NavBar>
      <div className="registrar-grid-container">
        <div className="padre-izquierda">
          <div className="hijo-izquierda">
            <div className="infoEvento">
              <InfoEvento
                nombre={nombre}
                fecha={fecha}
				hora={hora}
                descripcion={descripcion}
                id={id}
                imagen={urlImagen}
              />
            </div>
            {seleccionComida ? (
              <div>
                <div style={{ width: "300px" }}>
                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: "bolder",
                      marginLeft: "18px",
                      marginRight: "18px",
                    }}
                  >
                    Asientos seleccionados ({listaAsientos.length}/{maxAsientos}
                    ) :
                  </p>

                  <p
                    style={{
                      fontSize: "20px",
                      wordWrap: "break-word",
                      marginLeft: "15px",
                      marginRight: "15px",
                    }}
                  >
                    {groupTablesSeats(listaAsientos.toString())}
                  </p>
                </div>
                {listaAsientos.length > 0 &&
                tipoEvento != "Pago (sin comida)" ? (
                  <div
                    style={{
                      width: "350px",
                      alignContent: "center",
                      alignItems: "center",
                      marginLeft: "18px",
                    }}
                  >
                    <p style={{ fontSize: "20px", fontWeight: "bolder" }}>
                      Seleccione el tipo de comida: {totalComidas}/
                      {listaAsientos.length}
                    </p>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={require(`./img/vege.png`)}
                        alt="logo-titulo"
                        className="hola"
                      />
                      <p style={{ fontSize: "20px" }}> Vegetariano</p>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginLeft: "auto",
                        }}
                      >
                        <IncrementadorNum
                          style={{ margin: "30px" }}
                          contador={vegetariano}
                          setContador={setVegetariano}
                          blockMas={blockComidas}
                        ></IncrementadorNum>
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={require(`./img/pollo.png`)}
                        alt="logo-titulo"
                        className="hola"
                      />
                      <p style={{ fontSize: "20px" }}>Pollo</p>{" "}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginLeft: "auto",
                        }}
                      >
                        <IncrementadorNum
                          style={{ margin: "30px" }}
                          contador={pollo}
                          setContador={setPollo}
                          blockMas={blockComidas}
                        ></IncrementadorNum>{" "}
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={require(`./img/chancho.png`)}
                        alt="logo-titulo"
                        className="hola"
                      />
                      <p style={{ fontSize: "20px" }}>Chancho</p>{" "}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginLeft: "auto",
                        }}
                      >
                        <IncrementadorNum
                          style={{
                            margin: "30px",
                          }}
                          contador={chancho}
                          setContador={setChancho}
                          blockMas={blockComidas}
                        ></IncrementadorNum>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className="contenido-inferior">
              <div className="btnInferior">
                <input
                  type="submit"
                  value={derVisible ? "Volver atras" : "Continuar "}
                  style={{
                    cursor:
                      listaAsientos.length > 0 ? "default" : "not-allowed",

                    opacity: listaAsientos.length > 0 ? "1" : "0.65",
                  }}
                  className="btnAbajoContinuar"
                  onClick={btnContinuar}
                />
              </div>

              <Link
                to={`/panelAdmin/eventos/${id}/reporteSalon`}
                className="label"
                style={{ textAlign: "center", marginTop: "18px" }}
              >
                {!derVisible &&
                localStorage.getItem("nivelUsuario") != "ingeniero" ? (
                  <div className="btnInferior">
                    <input
                      type="submit"
                      value="Ver Reporte"
                      className="btnAbajoReporte"
                    />
                  </div>
                ) : null}
              </Link>
            </div>
          </div>
        </div>
        <div
          className={tamanoForm ? "padre-derecha" : "padre-derecha-continuar "}
        >
          <div className="hijo-derecha">
            {" "}
            {derVisible ? (
              <LlenarDatos
                listaAsientos={listaAsientos}
                id={id}
                nombre={nombre}
                isNew={isNew}
                idDocReserva={idDocReserva}
                idUpdate={idUpdate}
                setListaAsientos={setListaAsientos}
                maxAsientos={maxAsientos}
                setIsNew={setIsNew}
                isPago={isPago}
                setIdDocReserva={setIdDocReserva}
                setIdUpdate={setIdUpdate}
                cip={cip}
                costo={costo}
                pollo={pollo}
                chancho={chancho}
                vegetariano={vegetariano}
                lugar={"Salon de eventos"}
                tipoEvento={tipoEvento}
                nroTicket={listaRegistro ? listaRegistro.length : "0001"}
              ></LlenarDatos>
            ) : (
              <ItemSalon
                listaAsientos={listaAsientos}
                mesas={mesas}
                eliminarMesa={eliminarMesa}
                maxAsientos={maxAsientos}
                setListaAsientos={setListaAsientos}
                listaAsientosRegistrados={listaAsientosRegistrados}
                setMesas={setMesas}
                esReserva={true}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default RegistrarParticipanteSalon;
